import React, { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Tour from "../../components/explore/tour";
import CardExplore from "../../components/explore/cardExplore";
import Modal from "../../components/modal/form-modal/modal";
import { useZone } from "../../context/ZoneContext";
import { useFloors } from "../../api/zones/useFloors";

function ExploreTour({ lang }) {
  // ✅ أضفنا projectSlug لضمان بناء روابط صحيحة
  const { projectSlug, zoneId, unitCode, floorName } = useParams(); 
  const navigate = useNavigate();
  const { units } = useZone();
  const location = useLocation();

  const [villa, setVilla] = useState(location.state?.villa || null);
  const [currentFloor, setCurrentFloor] = useState(floorName || ""); 
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);

  const { floors, loading: floorsLoading } = useFloors(villa?.type_id || villa?.type?.id);
  const floorsList = Array.isArray(floors?.data) ? floors.data : [];

  // 1. البحث عن الفيلا في حالة الـ Refresh
  useEffect(() => {
    if (!villa && units?.length > 0 && unitCode) {
      const foundVilla = units.find((u) => String(u.code).trim() === String(unitCode).trim());
      if (foundVilla) {
        setVilla(foundVilla);
      }
    }
  }, [unitCode, units, villa]);

  // 2. تحديث الـ URL عندما يتغير الدور (تم إضافة projectSlug للمسار)
  useEffect(() => {
    // تأكدي من وجود projectSlug قبل عمل navigate
    if (currentFloor && villa && zoneId && projectSlug) {
      navigate(`/${projectSlug}/master-plan/${zoneId}/villa/${unitCode}/${currentFloor}`, { replace: true });
    }
  }, [currentFloor, zoneId, unitCode, projectSlug, navigate, villa]);

  // 3. تحديث الدور الافتراضي
  useEffect(() => {
    if (floorsList.length > 0 && !currentFloor) {
      setCurrentFloor(floorsList[0].name);
    }
  }, [floorsList, currentFloor]);

  // 4. مزامنة الحالة مع الـ URL في حالة الـ Back/Forward
  useEffect(() => {
    if (floorName && floorName !== currentFloor) {
      setCurrentFloor(floorName);
    }
  }, [floorName]);

  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth < 700);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  if (!villa) {
    return <div style={{ color: "white", textAlign: "center", marginTop: "50px" }}>Loading Villa...</div>;
  }

  return (
    <div
      className="explore-tour-wrapper"
      style={{
        background: "var(--foundation-black-light-active, #B0B0B0)",
        display: "flex",
        flexDirection: isMobile ? "column-reverse" : "row",
        minHeight: "calc(100vh - 76px)",
        width: "100%",
        padding: "0 18px",
        gap: isMobile ? "0" : "18px",
        direction: lang === "ar" ? "rtl" : "ltr",
      }}
    >
      <div style={{ zIndex: 1000, minWidth: isMobile ? "100%" : "336px" }}>
        <CardExplore
          lang={lang}
          villa={villa}
          floorsData={floorsList}
          currentFloor={currentFloor}
          onOpenModal={() => setShowModal(true)}
          setCurrentFloor={setCurrentFloor}
          isMobile={isMobile}
        />
      </div>

      <div style={{ flex: 1, position: "relative" }}>
        <Tour 
          typeId={villa.type_id || villa.type?.id} 
          currentFloor={currentFloor} 
          setCurrentFloor={setCurrentFloor} 
        />
      </div>

      {showModal && (
        <Modal
          show={showModal}
          onClose={() => setShowModal(false)}
          type="interactive"
          villa={villa}
        />
      )}
    </div>
  );
}

export default ExploreTour;